module.exports = __webpack_public_path__ + "media/icons/z-dark-4b618b3b.svg";